import * as React from 'react'
import { Bell, Menu, User } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { useMediaQuery } from '@/hooks/use-media-query'
import { cn } from '@/lib/utils'
import { useLocation } from 'react-router-dom'
import { UserAvatar } from '@/components/ui_custom/user-avatar'
import { useAuthStore } from '@/store/auth'
import { formatted_user_role, user_role } from '@/entities/user'
import { externalRoutes } from '@/utils/routes-util'
import { PasswordChangeDialog } from '@/components/dialogs/password-change-dialog'
import { useState } from 'react'

interface HeaderProps {
  onMenuClick?: () => void
  isOpen?: boolean
}

export function Header({ onMenuClick, isOpen }: HeaderProps) {
  const { user, logout } = useAuthStore()
  const location = useLocation()
  const isLgAndDown = useMediaQuery('(max-width:1123px)')
  const isMdAndDown = useMediaQuery('(max-width:768px)')
  const [isOpenPasswordChangeDialog, setIsOpenPasswordChangeDialog] = useState(false)
  if (externalRoutes.includes(location.pathname)) return <></>

  return (
    <header className={cn('sticky top-0 z-10 w-full flex bg-card/80 backdrop-blur-md border-b border-border shadow-soft', !isMdAndDown && 'justify-end')}>
      <div className={cn('w-full flex h-16 items-center justify-between px-3')}>
        <div className="flex">
          {isLgAndDown && (
            <Button variant="ghost" size="icon" className="mr-4 hover:bg-muted" onClick={onMenuClick}>
              <Menu className="h-6 w-6 text-foreground" />
              <span className="sr-only">Menu</span>
            </Button>
          )}
        </div>

        {import.meta.env.VITE_NODE_ENV !== 'production' && (
          <div className="flex items-center justify-center">
            <span className="text-xs font-semibold uppercase tracking-wide text-destructive-foreground bg-destructive px-3 py-1 rounded-full whitespace-nowrap">Ambiente de testes</span>
          </div>
        )}

        <div className="flex items-center justify-between space-x-2 md:justify-end pr-3">
          <div className="w-full flex-1" />
          <div className="flex items-center space-x-2">
            {/* <ThemeToggle /> */}

            {/*<TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button variant="outline" size="icon" className="relative" aria-label="Notifications">
                    <Bell className="h-5 w-5" />
                    <span className="absolute top-0 right-0 h-2 w-2 rounded-full bg-primary" />
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Notificações</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider> */}

            <div className="hidden xsAndUp:flex flex-col items-end px-3 leading-tight">
              <span className="font-semibold text-foreground text-sm whitespace-nowrap">{user?.name}</span>
              <span className="text-xs text-muted-foreground whitespace-nowrap">{user?.role == user_role.CUSTOMER ? 'Nutricionista' : formatted_user_role[user?.role as user_role]}</span>
            </div>

            <TooltipProvider delayDuration={0}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" size="icon" className="relative rounded-full" aria-label="User menu">
                        <UserAvatar />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="w-52">
                      <DropdownMenuLabel>Minha Conta</DropdownMenuLabel>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem className="cursor-pointer" onClick={() => setIsOpenPasswordChangeDialog(true)}>
                        Alterar senha
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem className="text-destructive cursor-pointer" onClick={() => logout()}>
                        Sair
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Menu do Usuário</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>

          {isOpenPasswordChangeDialog && <PasswordChangeDialog open={isOpenPasswordChangeDialog} cb={() => setIsOpenPasswordChangeDialog(false)} />}
        </div>
      </div>
    </header>
  )
}
